"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./cornerSprite.png')],
  frames: [[2, 292, 291, 286, 0, 71, 2], [1477, 292, 291, 286, 0, 71, 2], [1182, 292, 291, 286, 0, 71, 2], [887, 292, 291, 286, 0, 71, 2], [592, 292, 291, 286, 0, 71, 2], [297, 292, 291, 286, 0, 71, 2], [2, 582, 291, 286, 0, 71, 2], [1477, 2, 291, 286, 0, 71, 2], [1182, 2, 291, 286, 0, 71, 2], [887, 2, 291, 286, 0, 71, 2], [592, 2, 291, 286, 0, 71, 2], [297, 2, 291, 286, 0, 71, 2], [2, 2, 291, 286, 0, 71, 2]],
  animations: {
    still: {
      speed: 1,
      frames: [0, 0, 0]
    },
    'speech loop': {
      speed: 1,
      frames: [0, 0, 0, 1, 1, 2, 2, 2, 3, 3, 0, 0, 4, 4, 5, 5, 5, 6, 6, 0, 0, 4, 4, 7, 7, 7, 1, 1, 0, 0, 0, 6, 6, 5, 5, 5, 3, 3, 0, 0, 0, 0, 5, 5, 5, 3, 3, 8, 8, 1, 1, 2, 2, 2, 1, 1, 0, 0, 0, 0, 3, 3, 3, 7, 7, 1, 1, 1, 6, 6, 9, 9, 9, 1, 1, 2, 2, 2, 10, 10, 11, 11, 12, 12, 5, 5, 5, 6, 6]
    }
  }
};